import React, { useState, useEffect, useContext } from 'react';
import cn from "classnames";
import stylesCommon from "../../common.module.scss"
import CustomButton from '../../../custom/custom-button/CustomButton';
import CustomInput from '../../../custom/custom-input/CustomInput';
import axios from 'axios';
import { User } from "../../../../services";
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { configData } from '../../../../services/api-config';
import { AuthContext } from '../../../../context/auth.context';

const BIN_LENGTH = 12;

const validateUserName = (userName) => {
  const namePattern = /^[A-Za-zА-Яа-я]/;
  return namePattern.test(userName);
};

const SurveyUserRegistrationFirst = ({ updateStep, setData, data }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const auth = useContext(AuthContext);
  const [bin, setBin] = useState(data?.bin || '');
  const [companyName, setCompanyName] = useState(data?.companyName || '');
  const [isLoading, setIsLoading] = useState(false);

  const [errorTitleBin, setErrorTitleBin] = useState();
  const [errorTitleNameCompany, setErrorTitleNameCompany] = useState();

  const nextStep = async () => {
    setErrorTitleBin(null);
    setErrorTitleNameCompany(null);

    if (bin.length <= 1) {
      setErrorTitleBin("请输入正确的BIN");
      return;
    }
    if (!companyName) {
      setErrorTitleNameCompany(t('registrationSurveyUserFirst.validation.orgNameRequired'));
      return;
    }

    const isBinValid = await checkBin(bin);

    if (!isBinValid) {
      setErrorTitleBin(t('registrationSurveyUserFirst.validation.binExists'));
      return;
    }

    setData({
      ...data,
      bin: bin,
      companyName: companyName,
    });

    setIsLoading(true);
    try {
      const { isChecked, ...rest } = data;
      const newData = {
        ...rest,
        bin,
        companyName,
      };
      debugger;
      await User.registerNew(newData);
      toast.success(t('registrationSurveyUserSecond.toast.registrationSuccess'));
      await handleLogin();
    } catch (error) {
      console.error("Ошибка при регистрации нового пользователя:", error); 
      toast.error(t('registrationSurveyUserSecond.toast.registrationError')); 
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

    
  const handleLogin = async () => {
    debugger;
    const payload = {
      username: data.email ? data.email.toLowerCase() : data.email,
      password: data.password,
    };

    if (payload.username && payload.password) {
      try {
        const response = await axios.get(configData.BASE_URL + 'api/v1/users/login', {
          auth: payload,
          withCredentials: true
        });

        if (response.status === 200) {
          response.data.isAuthenticated = true;
          auth.login(response.data.accessToken);
          navigate("/onboarding");
        }
      } catch (error) {
        toast.error(t('registrationSurveyUserSecond.toast.loginError') + ": " + error.message);
      } finally {
      }
    } else {
      toast.error(t('registrationSurveyUserSecond.toast.loginError'));
    }
  };

  useEffect(() => {
    console.log('[data-2]', data);
  }, [data]);


  const checkBin = async (bin) => {
    try {
      const response = await User.checkBin(bin);
      if (!response.data.isExists) {
        return true
      } else if (response.data.isExists) {
        return false
      }
    } catch (error) {
      console.error('Error checking BIN:', error);
      return false;
    }
  };

  useEffect(() => {
    if (data.setCompanyName) setUserName(data.companyName);
  }, [data]);

  return (
    <div className={stylesCommon.fullWidth}>
      <div className={stylesCommon.form}>
        <CustomInput
          placeholder="123456789012"
          labelText={t('registrationSurveyUserFirst.label.binIin')} // Use specific label
          inputType="text"
          onChangeValue={setBin}
          value={bin}
          errorText={errorTitleBin}
          // maxLength={BIN_LENGTH}
          isBin
        />
        <CustomInput
          placeholder={t('registrationSurveyUserFirst.placeholder.orgName')}
          labelText={t('registrationSurveyUserFirst.label.orgName')}
          inputType="text"
          onChangeValue={setCompanyName}
          value={companyName}
          errorText={errorTitleNameCompany}
        />
      </div>
      <div className={stylesCommon.btns}>
        <CustomButton isFall isLoading={isLoading} text={t('registrationSurveyUserSecond.button.login')} onClick={nextStep} />
      </div>
    </div>
  );
};

export default SurveyUserRegistrationFirst;
